module.exports = __webpack_public_path__ + "static/media/basm.685f6fd8.jpeg";